import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const getUsersAccounts = () => {
  return Helpers.get(Constants.USERS_ACCOUNTS_URL);
};

export const getRoles = () => {
  return Helpers.get(Constants.LESSER_ROLES_URL);
};

export const getUserPermissions = () => {
  return Helpers.get(Constants.USERPERMISSIONS_URL);
};


export const createNewUser = user => {
  return Helpers.post(Constants.USER_URL, {}, user);
};

export const updateUser = user => {
  return Helpers.put(Constants.USER_URL, {}, user);
};

export const deleteUser = userId => {
  return Helpers.delete(`${Constants.USER_URL}/${userId}`);
};
